import { useEffect, useState } from "react";
import { useAuthContext } from "../../contexts/auth-context";
import { TProcessStates } from "../../lib/types/general";
import { TBusinessTypes, TBusinessTypesFilters } from "../../lib/types/business_types";
import { addBusinessType as _addBusinessType, updateBusinessType as _updateBusinessType, TUpdateBusinessTypeData } from "./backoffice-service";
import { getBusinessTypes as _getBusinessTypes } from "../generalInfo";

export const useBusinessTypes = () => {
    const { getUserTokenId } = useAuthContext();
    const [workingState, setWorkingState] = useState<TProcessStates>("idle");
    const [businessTypes, setBusinessTypes] = useState<TBusinessTypes[]>([]);

    const getAllBusinessTypes = async (filterName: TBusinessTypesFilters) => {
        setWorkingState("working");
        const _businessTypes = await _getBusinessTypes(filterName);
        setBusinessTypes(_businessTypes);
        setWorkingState("done");
    };

    const updateBusinessType = async (props: TUpdateBusinessTypeData) => {
        const userTokenId = await getUserTokenId();
        await _updateBusinessType(props, userTokenId);
        return await getAllBusinessTypes({ name: "" });
    };

    const addBusinessType = async (newName: string) => {
        const userTokenId = await getUserTokenId();
        await _addBusinessType(newName, userTokenId);
        return await getAllBusinessTypes({ name: "" });
    };

    useEffect(() => {
        getAllBusinessTypes({ name: "" });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return {
        getAllBusinessTypes,
        businessTypes,
        workingState,
        updateBusinessType,
        addBusinessType,
    };
};
